<template>

    <v-page-section>
        <template #header>
            <span>Company</span>
            <v-identifier :uuid="company.id" />
        </template>
        <template #body>
            <v-form-group label="Logo" caption="Minimum size: 300x300 pixels.">
                <v-uploader
                    :uploader-width="200"
                    :uploader-height="200"
                    :uploader-image="company.logo ? company.logo.link : null"
                    :uploader-url="'/companies/'+company.id+'/logo'">
                </v-uploader>
            </v-form-group>
            <v-form-group label="Name">
                <v-input class="w-500" placeholder="My Company Name" :model="params.name" @input="params.name = $event" />
            </v-form-group>
            <v-form-group label="Country">
                <v-select class="w-500" :model="params.country || ''" @input="params.country = $event">
                    <option value="">Select Country</option>
                    <optgroup>
                        <option value="US">United States</option>
                        <option value="CA">Canada</option>
                    </optgroup>
                    <optgroup>
                        <option v-for="c in countries" :key="c.value" :value="c.value">{{ c.label }}</option>
                    </optgroup>
                </v-select>
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" :loading="loading" @click.native="submit">Save</v-button>
        </template>
    </v-page-section>

</template>

<script>

import { countries } from 'countries-list';
import CompanyApi from '@api/CompanyApi';

export default {

    props: {
        company: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            params: {},
        }
    },

    computed: {

        countries() {
            let results = [];
            for (let c in countries) {
                results.push({ value: c, label: countries[c].name });
            }
            return results.sort(function(a, b) {
                return a.label.localeCompare(b.label)
            });
        },

    },

    mounted() {
        this.params = Object.assign({}, this.company);
    },

    methods: {

        submit() {
            this.loading = true;
            CompanyApi.updateCompany(this.company.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
